import "../../assets/css/results/results.css"

import Axios from "axios"
import { useEffect, useState } from "react"
import Swal from "sweetalert2"

import Map from "./map.jsx"
import Navigation from "./navigation.jsx"
import WantsView from "./wantsView.jsx"
import Details from "./details.jsx"
import SubscribeAlert from "../subscribeAlert/subscribeAlert.jsx"
import { useAuth } from "../../context/auth-context.jsx"
import { useGeneralStates } from "../../context/general-context.jsx"
import { ACTIONS, APP_ROUTES } from "../../utils/globalUtils.js"
import { useLocation, useNavigate } from "react-router-dom"
import { getImages } from "./utils.js"

export default function Results() {
    const { user, updateUser } = useAuth()
    const { state, dispatch, updateWantsMatrixReference } = useGeneralStates()
    const [navigationVisibility, setNavigationVisibility] = useState("move")
    const [citiesUrlPhotos, setCitiesUrlPhotos] = useState([])

    const navigate = useNavigate()
    const currentUrl = useLocation()

    // get user with token in url params
    useEffect(() => {
        const searchParams = new URLSearchParams(currentUrl.search);
        const token = searchParams.get("teaserReportToken");

        if (!token) return

        const cleanedUrl = "/results"
        window.history.replaceState(null, "", cleanedUrl);

        Axios.get(`${process.env.REACT_APP_USER_WITH_TOKEN}${token}`).then(res => {
            updateUser(res.data?.user)

            const {
                clientLocation,
                supplierLocation
            } = res.data

            dispatch({ type: ACTIONS.setClientAndSupplierLocation, payload:  { clientLocation, supplierLocation } })
        }).catch(err => {
            navigate(APP_ROUTES.login)
            dispatch({ type: ACTIONS.setShowColumn, payload: "" })
            console.log(err?.response?.data?.message || "Error trying to get report")
        })
    }, [])

    // get wants matrix reference
    useEffect(() => {
        Axios.get(process.env.REACT_APP_WANTS_REFERENCE).then(res => {
            updateWantsMatrixReference(res.data?.data)
        }).catch(err => {
            Swal.fire({
                icon: "error",
                title: err?.response?.data?.message || "Error trying to get wants reference",
                showConfirmButton: false,
                showCancelButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
            console.log(err?.response?.data?.message || "Error trying to get wants reference")
        })
    }, [])

    useEffect(() => {
        if (!user || citiesUrlPhotos.length !== 0) return
        
        async function getCitiesPhotos() {
            const scriptId = 'google-maps-script';
            const existingScript = document.getElementById(scriptId);

            if (!existingScript) {
                const script = document.createElement('script');
                script.id = scriptId;
                script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_KEY}&libraries=places`;
                script.async = true;
                try {
                    await new Promise((resolve, reject) => {
                        document.body.appendChild(script);
                        script.onload = resolve;
                        script.onerror = reject;
                    });
                } catch (error) {
                    console.log(error)
                }
            }
        
            if (window.google?.maps) {
                try {
                    const cities = user.selectedCities
                    const citiesWithPhoto = await getImages(cities);
            
                    setCitiesUrlPhotos(citiesWithPhoto)
                } catch (error) {
                    console.log(error)
                }
            }
        }

        getCitiesPhotos()

        return () => {
            const script = document.getElementById('google-maps-script');

            if (script) {
                document.body.removeChild(script);
            }
        };
    }, [user, citiesUrlPhotos])

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Cancel the event as returning a non-void value will prompt a confirmation dialog
            event.preventDefault();
            // Chrome requires returnValue to be set
            event.returnValue = '';

            // Perform any additional cleanup or logic you need before the page unloads
            // For example, you might want to save data or show a confirmation message
            // console.log("User is trying to leave the page");
        };

        // Add the event listener when the component mounts
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Remove the event listener when the component unmounts
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    if (!user || state.wantsMatrixReference.length === 0) return null

    return (
        <section className="resultsContainer">
            <SubscribeAlert />
            
            <Navigation navigationVisibility={navigationVisibility} />

            <WantsView />

            <Details />

            <Map setNavigationVisibility={setNavigationVisibility} citiesUrlPhotos={citiesUrlPhotos} />
        </section>
    )
}
